import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit {

  @Input() title: string;
  @Input() text: string;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
  }

  confirm() {
    this.activeModal.close(true);
  }
}
